module.exports = __webpack_public_path__ + "fonts/Roboto-500-cyrillic-ext40.3004e52.woff2";